import React from "react";
import { Typography, Divider } from "@material-ui/core";
import { QuestionTypes, QuestionTypeLabelKeys, NodeTypes } from "../utils/constants";
import { NodeIcons, QuestionTypeIcons } from "./nodeIcons";

const nodeTemplates = [
  {
    id: "diagnostic-flow-palette-start",
    type: NodeTypes.START,
    labelKey: "Start",
    descriptionKey: "DiagnosticFlowStartDescription",
    color: "#43a047",
    icon: NodeIcons.START,
  },
  {
    id: "diagnostic-flow-palette-free-text",
    type: NodeTypes.QUESTION,
    questionType: QuestionTypes.FREE_TEXT,
    labelKey: QuestionTypeLabelKeys[QuestionTypes.FREE_TEXT],
    descriptionKey: "DiagnosticFlowFreeTextDescription",
    color: "#1976d2",
    icon: QuestionTypeIcons[QuestionTypes.FREE_TEXT],
  },
  {
    id: "diagnostic-flow-palette-yes-no",
    type: NodeTypes.QUESTION,
    questionType: QuestionTypes.YES_NO,
    labelKey: QuestionTypeLabelKeys[QuestionTypes.YES_NO],
    descriptionKey: "DiagnosticFlowYesNoDescription",
    color: "#f57c00",
    icon: QuestionTypeIcons[QuestionTypes.YES_NO],
  },
  {
    id: "diagnostic-flow-palette-time-duration",
    type: NodeTypes.QUESTION,
    questionType: QuestionTypes.TIME_DURATION,
    labelKey: QuestionTypeLabelKeys[QuestionTypes.TIME_DURATION],
    descriptionKey: "DiagnosticFlowTimeDurationDescription",
    color: "#7b1fa2",
    icon: QuestionTypeIcons[QuestionTypes.TIME_DURATION],
  },
  {
    id: "diagnostic-flow-palette-list",
    type: NodeTypes.QUESTION,
    questionType: QuestionTypes.LIST,
    labelKey: QuestionTypeLabelKeys[QuestionTypes.LIST],
    descriptionKey: "DiagnosticFlowListDescription",
    color: "#00897b",
    icon: QuestionTypeIcons[QuestionTypes.LIST],
  },
  {
    id: "diagnostic-flow-palette-end",
    type: NodeTypes.TERMINAL,
    labelKey: "End",
    descriptionKey: "DiagnosticFlowEndDescription",
    color: "#e53935",
    icon: NodeIcons.END,
  },
];

export default function Sidebar({ resources = {} }) {
  const onDragStart = (event, template) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const payload = {
      type: template.type,
      questionType: template.questionType,
      grabOffsetX: event.clientX - rect.left,
      grabOffsetY: event.clientY - rect.top,
    };
    event.dataTransfer.setData("application/reactflow", JSON.stringify(payload));
    event.dataTransfer.effectAllowed = "move";
  };

  return (
    <div
      style={{
        width: "220px",
        borderRight: "1px solid #e8e8e8",
        background: "#fafafa",
        padding: "16px",
        overflowY: "auto",
        flexShrink: 0,
      }}
    >
      <Typography
        variant="subtitle2"
        style={{ fontWeight: 700, marginBottom: "4px", color: "#333" }}
      >
        {resources["DiagnosticFlowNodeTypes"]}
      </Typography>
      <Typography
        variant="caption"
        style={{ display: "block", marginBottom: "14px", color: "#888" }}
      >
        {resources["DiagnosticFlowDragOntoCanvas"]}
      </Typography>

      <Divider style={{ marginBottom: "14px" }} />

      {nodeTemplates.map((template, index) => (
        <div
          key={index}
          id={template.id}
          draggable
          onDragStart={(e) => onDragStart(e, template)}
          style={{
            padding: "10px 12px",
            borderRadius: "8px",
            border: `1.5px solid ${template.color}30`,
            background: "#fff",
            marginBottom: "8px",
            cursor: "grab",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            transition: "all 0.15s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.borderColor = template.color;
            e.currentTarget.style.boxShadow = `0 2px 8px ${template.color}20`;
            e.currentTarget.style.transform = "translateY(-1px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = `${template.color}30`;
            e.currentTarget.style.boxShadow = "none";
            e.currentTarget.style.transform = "none";
          }}
        >
          <div
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "8px",
              background: `${template.color}14`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <template.icon style={{ fontSize: "18px", color: template.color }} />
          </div>
          <div style={{ minWidth: 0 }}>
            <div
              title={resources[template.labelKey]}
              style={{
                fontSize: "13px",
                fontWeight: 600,
                color: "#333",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {resources[template.labelKey]}
            </div>
            <div
              title={resources[template.descriptionKey]}
              style={{
                fontSize: "11px",
                color: "#999",
                marginTop: "1px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {resources[template.descriptionKey]}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
